import ErrorFeedback from 'components/ui/Form/controls/ErrorFeedback/ErrorFeedback';
import { IDefaultControlProps } from 'components/ui/Form/Form';
import { useFormContext } from 'react-hook-form';
import { getDeepValue } from 'utils/helpers';

const Checkbox = (props: IDefaultControlProps) => {
  const { name, label } = props;
  const {
    register,
    formState: { errors }
  } = useFormContext();
  const error = getDeepValue(errors, name);

  return (
    <>
      <div className="flex items-center">
        <input
          {...register(name)}
          id={name}
          type="checkbox"
          className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 flex-shrink-0"
        />
        <label htmlFor={name} className="ml-2 text-sm text-darkBlue">
          {label}
        </label>
      </div>
      {error?.message && <ErrorFeedback message={error.message as unknown as string} />}
    </>
  );
};

export default Checkbox;
